__turbopack_context__.v({
  "className": "bowlby_one_779527da-module__z9L4oq__className",
  "variable": "bowlby_one_779527da-module__z9L4oq__variable",
});
